export const PROJECT_OWNER_AVATAR_PALETTE = [
  "bg-sky-500/15 text-sky-700 dark:bg-sky-400/20 dark:text-sky-200",
  "bg-emerald-500/15 text-emerald-700 dark:bg-emerald-400/20 dark:text-emerald-200",
  "bg-amber-500/20 text-amber-800 dark:bg-amber-400/20 dark:text-amber-200",
  "bg-rose-500/15 text-rose-700 dark:bg-rose-400/20 dark:text-rose-200",
  "bg-violet-500/15 text-violet-700 dark:bg-violet-400/20 dark:text-violet-200",
  "bg-teal-500/15 text-teal-700 dark:bg-teal-400/20 dark:text-teal-200",
] as const;

/** The first letter of each of the first two words, uppercased; null when the name has none. */
export function ownerInitials(name: string | null): string | null {
  if (name === null) return null;
  const initials = name
    .trim()
    .split(/\s+/u)
    .filter((word) => word.length > 0)
    .slice(0, 2)
    .map((word) => Array.from(word)[0])
    .join("");
  return initials.length > 0 ? initials.toUpperCase() : null;
}

export function ownerPaletteIndex(userId: string, paletteSize: number): number {
  let hash = 0;
  for (let index = 0; index < userId.length; index += 1) {
    hash = (Math.imul(hash, 31) + userId.charCodeAt(index)) >>> 0;
  }
  return hash % paletteSize;
}

export function ownerAvatarColorClass(userId: string): string {
  return PROJECT_OWNER_AVATAR_PALETTE[
    ownerPaletteIndex(userId, PROJECT_OWNER_AVATAR_PALETTE.length)
  ]!;
}

/** An `aria-describedby` value naming `existing`'s ids and then `id`. */
export function withDescriptionId(existing: string | undefined, id: string): string {
  return [...(existing ?? "").split(/\s+/u).filter((ref) => ref.length > 0), id].join(" ");
}
